import { render, staticRenderFns } from "./ReportManagement_Component.vue?vue&type=template&id=e7795b20&"
import script from "./ReportManagement_Component.vue?vue&type=script&lang=js&"
export * from "./ReportManagement_Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports